module.exports = __webpack_public_path__ + "static/media/reactiveColaborator.654dc303.svg";